import React, { memo } from 'react';
import { Tag } from 'src/app/common/components/tag/tag.component';
import { ProspectTypeTagProps, useProspectTypeTag } from './prospect-type-tag.hook';

export const ProspectTypeTag: React.FC<ProspectTypeTagProps> = memo((props: ProspectTypeTagProps) => {
  const { status, configs } = useProspectTypeTag(props);
  return <Tag<string> value={status} configs={configs} />;
});
